import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Accordion, BoxFull, TransactionalSubheader } from "iuvity-ui-components";
import { Header } from "../../components";
import { TrxGeneralInfo } from "../../components/transactions/TrxGeneralInfo";
import { TrxDataTableActions } from "../../components/transactions/TrxDatatableActions";
import {
  NewCustomDialog,
  NewDialogProps,
} from "../../components/dialog/NewCustomDialog";
import { useTransactionFields } from "../../hooks/useTransactionFields";
import { AppContext } from "../../context";
import { NewTransactionPage } from "./NewTransactionPage";

export const TransactionConfigurationPage = () => {
  const navigate = useNavigate();
  const {
    t,
    appState: { user },
  } = useContext(AppContext);

  const { transactionFieldAction } = useTransactionFields();
  const [modalProps, setModalProps] = useState<NewDialogProps>({
    visible: false,
  } as NewDialogProps);

  return (
    <>
      {/* <Header
        welcomeMessage={t("Dashboard.welcomeTitle")}
        userName={user?.name}
      /> */}
      
      <TransactionalSubheader
        subheaderTitle={
          <div
            style={{
              position: "relative",
              left: '-3rem'
            }}
          >
            <i
              className="iu iu-icon-left pr-3"
              onClick={() => navigate("/transactions")}
              aria-hidden="true"
              style={{
                fontSize: "var(--font-size-tablet-title)",
                cursor: "pointer",
              }}
            />
            {t("Transactions.configTransactionLabel")}
          </div>
        }
      >
        <TransactionalSubheader.BreadCrumb
          id={t("Transactions.configProductLabel")}
          disabledDefaultHome={true}
          breadcrumbsHomeItem={{
            icon: "iu iu-icon-home",
            command: () => navigate("/"),
          }}
          breadcrumbsItems={[
            {
              label: t("Transactions.transactionAdminTitle"),
              command: () => navigate("/transactions"),
              style: { fontFamily: "var(--fontBarlowSemiBold)" },
            },
            {
              label: t("Transactions.configTransactionLabel"),
              disabled: true
            },
          ]}
        />
        <TransactionalSubheader.Title />
        <div className="t-subheader-content">
          <span>{t("Transactions.configDescriptionLabel")}</span>
        </div>
      </TransactionalSubheader>

      <NewTransactionPage update={true} />

      <div id="margin-fixed-bgscreen">
        <BoxFull className="py-5" style={{ background: "transparent" }}>
          <Accordion
            activeIndex={null}
            id="accordion"
            items={[
              {
                children: (
                  <TrxGeneralInfo
                    filter="ID"
                    fieldActionFn={transactionFieldAction}
                    auxModalController={setModalProps}
                  />
                ),
                disabled: false,
                header: t("Transactions.advanceConfigurationLabel"),
                key: "222222",
              },
              {
                children: (
                  <TrxDataTableActions
                    serviceApi="paymentDetail&transferDetail"
                    auxModalController={setModalProps}
                  />
                ),
                disabled: false,
                header: t("Transactions.additionalInfoFieldsLabel"),
                key: "333333",
              },
            ]}
          />
        </BoxFull>
      </div>

      <NewCustomDialog
        title={modalProps.title}
        visible={modalProps.visible}
        content={modalProps.content}
        handleModalState={setModalProps}
        onConfirm={modalProps.onConfirm}
      />
    </>
  );
};
